import LinkHOC from 'platform/react/hoc/link'
import Section from 'ui/Element/Section'

const SectionAsLink = LinkHOC(Section)

export default SectionAsLink
